const setChildren = (id = 0, val = null) => {
  return {
    type: 'SET_CHILDREN',
    id,
    data: val,
  }
}

export default {
  setChildren,
}
